export const SETTLEMENT_OPTIONS = {
  STATUS: 12,
  SHOW_BY: 13,
  SHOW_FOR: 14,
  TIME_PERIOD: 15,
  BUSINESS_UNIT: 22,
};
